type IAppConsts = {
  ServiceBaseUrl: string | undefined
};

export const AppConsts: IAppConsts = {
  ServiceBaseUrl: process.env.REACT_APP_SERVICE_BASE_URL
};